import { render, staticRenderFns } from "./TreinamentoIA.vue?vue&type=template&id=334e6ccb&scoped=true"
import script from "./TreinamentoIA.vue?vue&type=script&lang=js"
export * from "./TreinamentoIA.vue?vue&type=script&lang=js"
import style0 from "./TreinamentoIA.vue?vue&type=style&index=0&id=334e6ccb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334e6ccb",
  null
  
)

export default component.exports